module.exports = __webpack_public_path__ + "static/media/arch-11.d90b0267.jpg";